import { Injectable } from '@angular/core';
import {AgregationService, BundleCall} from '@ispm-client/modules/aggregator/services';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs';

@Injectable()
export class ModelViewerService {
    constructor( private _agregationService: AgregationService,private _bundleCall: BundleCall) {
    }
    public getDefaultMeshData(modelData: any): Observable<any> {
        return !(modelData && modelData.diagnosticReportId) ? of({ }) : this._agregationService.registerQuery([
            {
                identifier: '3dModelMeshData',
                targetResource: 'DiagnosticReport',
                queryString: `context=$(currentPatient.id)&_id=${modelData.diagnosticReportId}`,
                prefetch: true,
                identifierType: "object"
            }
        ]);
    }

    public updateReport(payload){
        let updateQuery={queries:[{
                targetResource: 'DiagnosticReport',
                formId: 'PAN-CANCER-3D-MODEL',
                data: payload
            }]};
        this._bundleCall.updateCall(updateQuery).publish().connect();
    }
}
